import React, { useState, useEffect, useMemo } from "react";
import { CircularProgress } from "@mui/material";

import DynamicForm from "../../../../data/Axios/DynamicForm";

import { AccountsandFinanceurl } from "../../../../config";
import Swal from "sweetalert2";
import { accountCategoryFields } from "../../../../data/DynamicTable/AccountsDynamicForms";
import { generateAndExecuteMutation } from "../../../../data/Axios/DynamicService";

const base_url = AccountsandFinanceurl.uri;

const AccountCategoryForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const companyId = parseInt(decodedToken.CompanyId);


  const steps = useMemo(() => [
      {
        stepLabel: "Basic Information",
        stepDescription: "Account Categories",
        icon: "assignment_ind",
        fields: ["categoryName","currency", "rate"],
      },
    ], []);
      const fields   = useMemo(() => [
      {
        name: "categoryName",
        label: "Category Name *",
        type: "text",
        gridColumn: "span 2",
        required: true,
      },
      // {
      //   name: "currency",
      //   label: "Currency *",
      //   type: "text",
      //   gridColumn: "span 2",
      //   required: true,
      // },
      // {
      //   name: "rate",
      //   label: "Rate *",
      //   type: "number",
      //   gridColumn: "span 2",
      //   required: true,
      // },
      //   {
      //     name: "parentAccount",
      //     label: "Parent Account",
      //     type: "text",
      //     gridColumn: "span 2",
      //   },
      //   {
      //     name: "oldParent",
      //     label: "Old Parent",
      //     type: "text",
      //     gridColumn: "span 2",
      //   }
    ], []);

  const initialValues = {
    id: props.data?.id ?? "",
    categoryName: props.data?.categoryName ?? "",
    companyId: props.data?.companyId ?? companyId,
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const { categoryName } = values;

      const mutationData = props.isEditing
        ? {
            id: props.data.id,
            categoryName,
            // parentAccount,
            // oldParent,
            companyId: companyId,
            //  updatedBy: userId,
          }
        : {
            categoryName,
            // parentAccount,
            // oldParent,
            companyId: companyId,
            // createdBy: userId,
          };

      const response = await generateAndExecuteMutation(
        props.isEditing ? "updateAccountCategory" : "createAccountCategory",
        mutationData,
        props.isEditing ? "updatedCategory" : "newCategory",
        base_url
      );

      if (Object.values(response)[0] != null) {
        props.onClose();
        props.onAction();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Account category ${
            props.isEditing ? "updated" : "created"
          } successfully.`,
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };

  return (
    <DynamicForm
      initialValues={initialValues}
      fields={fields}
      onSubmit={handleSubmit}
      title={props.isEditing ? "Edit Account Category" : "Create Account Category"}
      subtitle={
        props.isEditing
          ? "Edit an Existing Account Category"
          : "Create a New Account Category"
      }
    />
  );
};

export default AccountCategoryForm;
